import { Pipe, PipeTransform } from '@angular/core';
import { makeThumbUrl } from 'src/app/core/utils/dom-utils';

@Pipe({
  name: 'thumb',
  standalone: false,
})
export class ThumbPipe implements PipeTransform {
  public transform(fileId: string, width: number): string | undefined {
    return fileId ? makeThumbUrl(fileId, width) : void 0;
  }
}
